import request from "../utils/request.js"

// 登录
export const getLogin = (data) => {
    return request({
        url: '/api/loginWebsite',
        method: 'post',
        data
    })
};

// 注册
export const getRegister = (data) => {
    return request({
        url: '/api/registerWebsite',
        method: 'post',
        data
    })
};

// 下载
export const getDowWebsite = (data) => {
    return request({
        url: '/api/dowWebsite',
        method: 'post',
        data
    });
};

// 设备列表
export const getListWebsite = () => {
    return request({
        url: '/api/equipmentListWebsite',
        method: 'post'
    });
};

// 解绑设备
export const getOutBindWebsite = (data) => {
    return request({
        url: '/api/outBindWebsite',
        method: 'post',
        data
    });
};

// 兑换
export const redeemCodeWebsite = (data) => {
    return request({
        url: '/api/redeemCodeWebsite',
        method: 'post',
        data
    });
};

// 商城
export const planFetchWeb = (data) => {
    return request({
        url: '/api/planFetchWeb',
        method: 'post',
        data
    });
};

// 下单并且跳转支付
export const payWebsite = (data) => {
    return request({
        url: '/api/payWebsite',
        method: 'post',
        data
    });
};
